import { defineComponent as _defineComponent } from 'vue';
import { EYE, EYE_OFF, EXPORT, EXPAND_ARROW } from '@/constants/icons';
import { DEFAULT_DATE_TIME_FORMAT, formatDate } from '@/utils/formatting';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'img-tag',
  props: {
    src: null,
    lazySrc: {
      default: ''
    },
    alt: {
      default: ''
    },
    downloadUrl: {
      default: ''
    },
    width: {
      default: ''
    },
    height: {
      default: ''
    },
    contain: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    aspectRatio: {
      default: undefined
    },
    maxWidth: {
      default: undefined
    },
    minWidth: {
      default: undefined
    },
    maxHeight: {
      default: undefined
    },
    minHeight: {
      default: undefined
    },
    visible: {
      type: Boolean,
      default: false
    },
    showVisibleIcon: {
      type: Boolean,
      default: false
    },
    showDownloadIcon: {
      type: Boolean,
      default: false
    },
    disableVisibleIcon: {
      type: Boolean,
      default: false
    },
    showDetailsInfo: {
      default: null
    },
    showEnlargeIcon: {
      type: Boolean,
      default: false
    }
  },
  emits: ['mouse-enter', 'mouse-leave', 'click', 'change-visibility', 'change-enlarge'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const imageBinding = computed(() => {
      return {
        src: props.src,
        lazySrc: props.lazySrc,
        alt: props.alt,
        width: props.width,
        height: props.height,
        contain: props.contain,
        class: props.rounded ? 'roundedCorner' : '',
        aspectRatio: props.aspectRatio,
        'max-width': props.maxWidth,
        'min-width': props.minWidth,
        'max-height': props.maxHeight,
        'min-height': props.minHeight
      };
    });
    const emitVisibility = () => {
      if (props.disableVisibleIcon) return false;
      emit('change-visibility', !props.visible);
    };
    const downloadImage = () => {
      window.open(props.downloadUrl);
    };
    return {
      __sfc: true,
      props,
      emit,
      imageBinding,
      emitVisibility,
      downloadImage,
      EYE,
      EYE_OFF,
      EXPORT,
      EXPAND_ARROW,
      DEFAULT_DATE_TIME_FORMAT,
      formatDate
    };
  }
});